export default {
  name: 'cardModal',
  type: 'object',
  properties: {
    companyId: {
      type: 'integer',
      fieldRequired: 'true'
    },
    cardNumber: {
      type: 'string',
      fieldRequired: 'true'
    }
  }
};
